/* eslint-disable no-mixed-operators */
/* eslint-disable eqeqeq */
/**
 * 从资质数据结构中获取资质对应的图片对象
 * @param {object} ctf
 *
 */
import $ from 'jquery';
import _ from 'lodash';
// by init
const findImagesByInit = (code, certifications) => {
  let i;
  let j;
  let res = [];
  let images;
  let randomNum;
  let approvalStatus;
  let certificationId;

  if (!certifications) return res;

  for (i in certifications) {
    if (certifications[i].code == code) {
      randomNum = Math.floor(100000 * Math.random());
      certifications[i].images = certifications[i].images_list;

      for (j in certifications[i].images) {
        certifications[i].images[j].id = `${code}_${randomNum}_${Math.floor(100000 * Math.random())}`;
      }

      images = {
        id: `${code}_${randomNum}`,
        data: certifications[i].images,
      };
      res.push(images);

      approvalStatus = certifications[i].approval_status || '';
      certificationId = certifications[i].certification_id || '';
    }
  }

  return {
    images: res,
    approval_status: approvalStatus,
    certification_id: certificationId,
  };
};

const findImages = (code, certifications) => {
  let i;
  let j;
  let res = [];
  let images;
  let randomNum;
  let approvalStatus;
  let certificationId;
  let rejectReason;
  let expand_fields;
  if (!certifications) return res;

  for (i in certifications) {
    if (certifications[i].certification_code == code) {
      randomNum = Math.floor(100000 * Math.random());

      for (j in certifications[i].images) {
        certifications[i].images[j].id = `${code}_${randomNum}_${Math.floor(100000 * Math.random())}`;
      }

      images = {
        id: `${code}_${randomNum}`,
        data: certifications[i].images,
        approval_status: certifications[i].approval_status,
        reject_reason: certifications[i].reject_reason,
        expand_fields: certifications[i].expand_fields,
      };
      res.push(images);
      // approvalStatus = certifications[i].approval_status;
      // certificationId = certifications[i].certification_id || '';
      // rejectReason = certifications[i].reject_reason;
      expand_fields = certifications[i].expand_fields;
    }
  }

  // alfielv 2014-01-10
  // 疑似历史bug：资质组永远取的最后一份资质approval_status、certification_id等等
  // 更正为：组级别资质状态取第一个approval_status !== 1的资质。如果没有，取certifications最后一个也就是approval_status === 1的资质
  const groupCertification = _.find(certifications, (item) => item?.approval_status !== 1) || _.last(certifications);
  if (groupCertification) {
    approvalStatus = groupCertification.approval_status;
    certificationId = groupCertification.certification_id || '';
    rejectReason = groupCertification.reject_reason;
  }

  return {
    images: res,
    approval_status: approvalStatus,
    certification_id: certificationId,
    reject_reason: rejectReason,
    expand_fields,
  };
};

// 将一份资质的数据转为IndustryDetail需要的数据格式
// 1. 将images对象移到对应的code对象里，并返回该控件是否有图片的判断
// 2. 可多页的资质，增加多页是否勾选的字段
// 3. 添加multiple字段
export const formatCertificationDataByInit = (ctf, certifications) => {
  let res = $.extend(true, {}, ctf);
  let i;
  let j;
  let codes = res.certification_codes;
  let isEmpty = false;
  let minCode;

  // 删除code数据中不必要的字段
  for (i in codes) {
    minCode = {
      certification_code: codes[i].certification_code,
      certification_name: codes[i].certification_name,
      max_page_count: codes[i].max_page_count,
      min_page_count: codes[i].min_page_count,
      status: codes[i].status,
    };

    if (codes[i].max_page_count > 1) {
      minCode.multiple = false;
    }
    codes[i] = minCode;
  }

  // 如果是optional的，code_checked字段用于指定哪个code被选中
  if (res.certification_relation_type == 'optional') {
    res.code_checked = codes[0].certification_code;
  }

  if (Array.isArray(certifications) && certifications.length > 0) {
  } else {
    isEmpty = true;
  }

  for (i in codes) {
    const { images = [], approval_status = '', certification_id = '' } = findImagesByInit(codes[i].certification_code, certifications);

    if (images.length > 0 && res.certification_relation_type == 'optional') {
      res.code_checked = codes[i].certification_code;
    }

    // 在images中补齐同个资质份数
    const leftCopy = res.max_copy_count - images.length;

    // 多页的添加multiple字段
    if (codes[i].max_page_count > 1) {
      for (j = 0; j < images.length; j++) {
        if (images[j].data.length > 1) {
          images[j].multiple = true;
        } else {
          images[j].multiple = false;
        }
      }
    }

    if (leftCopy > 0 && res.certification_relation_type != 'range') {
      for (j = 0; j < leftCopy; j++) {
        images.push({
          id: `${codes[i].certification_code}_${Math.floor(100000 * Math.random())}`,
          data: [],
        });
      }
    }

    codes[i].images = images;
    codes[i].approval_status = approval_status;
    codes[i].certification_id = certification_id;
  }

  delete res.certifications;
  return {
    data: res,
    isEmpty,
  };
};

export const formatCertificationData = (ctf) => {
  let res = $.extend(true, {}, ctf);
  let certifications = [];
  let i;
  let j;
  let codes = res.certification_codes;
  let isEmpty = false;
  let minCode;

  // 删除code数据中不必要的字段
  for (i in codes) {
    minCode = {
      certification_code: codes[i].certification_code,
      certification_name: codes[i].certification_name,
      max_page_count: codes[i].max_page_count,
      min_page_count: codes[i].min_page_count,
      status: codes[i].status,
      field_definition_list: codes[i].field_definition_list || [],
    };

    if (codes[i].max_page_count > 1) {
      minCode.multiple = false;
    }
    codes[i] = minCode;
  }

  // 如果是optional的，code_checked字段用于指定哪个code被选中
  if (res.certification_relation_type == 'optional') {
    res.code_checked = codes[0].certification_code;
  }

  if (res.hasOwnProperty('certifications') && Array.isArray(res.certifications) && res.certifications.length > 0) {
  } else {
    isEmpty = true;
  }

  certifications = res.certifications;

  for (i in codes) {
    const { images = [], approval_status = '', certification_id = '', reject_reason, expand_fields = [] } = findImages(codes[i].certification_code, certifications);

    if (images.length > 0 && res.certification_relation_type == 'optional') {
      res.code_checked = codes[i].certification_code;
    }

    // 在images中补齐同个资质份数
    const leftCopy = res.max_copy_count - images.length;

    // 多页的添加multiple字段
    if (codes[i].max_page_count > 1) {
      for (j = 0; j < images.length; j++) {
        if (images[j].data.length > 1) {
          images[j].multiple = true;
        } else {
          images[j].multiple = false;
        }
      }
    }

    if (leftCopy > 0 && res.certification_relation_type != 'range') {
      for (j = 0; j < leftCopy; j++) {
        images.push({
          id: `${codes[i].certification_code}_${Math.floor(100000 * Math.random())}`,
          data: [],
        });
      }
    }
    // console.log()
    codes[i].images = images;
    codes[i].approval_status = approval_status;
    codes[i].certification_id = certification_id;
    codes[i].reject_reason = reject_reason;
    codes[i].expand_fields = expand_fields;
  }

  delete res.certifications;
  return {
    data: res,
    isEmpty,
  };
};

// 遍历industryData， 找到对应的optional 资质，并改变codeChecked字段值
export const setOptionalCodeChecked = (industryData, industryId, codeChecked) => {
  const id = industryId;
  const info = $.extend(true, {}, industryData);
  let item; let i; let j; let k; let codeData;

  if ((id && info.industry_id == id) || info.business_range_id == id) {
    if (info.certification_group) {
      for (i in info.certification_group) {
        item = info.certification_group[i];
        for (j in item.certification_codes) {
          codeData = item.certification_codes[j];
          // 找到那个资质了
          if (codeData.certification_code == codeChecked) {
            item.code_checked = codeChecked;
          }
        }
      }
    }
  } else {
    if (info.business_range && info.business_range.length > 0) {
      for (k in info.business_range) {
        info.business_range[k] = setOptionalCodeChecked(info.business_range[k], industryId, codeChecked);
      }
    }
  }

  return info;
};

// 找到某一个特定的资质
export const findCertification = (info, industryId, code) => {
  const id = industryId;
  let item; let i; let j; let k; let codeData; let result;

  if (!id || !info) return null;

  if (info.industry_id == id || info.business_range_id == id) {
    if (info.certification_group) {
      for (i in info.certification_group) {
        item = info.certification_group[i];
        for (j in item.certification_codes) {
          codeData = item.certification_codes[j];
          // 找到那个资质了
          if (codeData.certification_code == code) {
            return codeData;
          }
        }
      }
    }
  } else {
    if (info.business_range && info.business_range.length > 0) {
      for (k in info.business_range) {
        result = findCertification(info.business_range[k], industryId, code);
        if (result) {
          return result;
        }
      }
    }
  }

  return null;
};

/**
 * 把图片添加到industryData， 通过image的code来定位，找到对应的images对象
 *
 * @param      {object}  info    industryData
 * @param      {object}  img     The image
 */
export const addImgToIndustryData = (industryData, img) => {
  const id = img.industry_id;
  const info = $.extend(true, {}, industryData);
  let item; let i; let j; let k; let codeData; let randomNum; let idArr;

  if ((id && info.industry_id == id) || info.business_range_id == id) {
    if (info.certification_group) {
      for (i in info.certification_group) {
        item = info.certification_group[i];
        for (j in item.certification_codes) {
          codeData = item.certification_codes[j];
          if (codeData.certification_code == img.code) {
            if (!codeData.images) {
              codeData.images = [];
            }

            idArr = img.name.split('_');

            // 加一页
            if (idArr.length == 4) {
              let certiId = `${idArr[1]}_${idArr[2]}`;
              $('body').append($(`#${img.file}`));
              for (k in codeData.images) {
                if (codeData.images[k].id == certiId) {
                  codeData.images[k].data.push({
                    image_url: img.url,
                    image_id: img.image_id || '',
                    name: img.name,
                    id: `${idArr[1]}_${idArr[2]}_${idArr[3]}`,
                    file: img.file || '',
                    fileData: img.fileData || '',
                  });
                }
              }
              // 补充资质，不允许多页
            } else if (idArr.length == 3 && idArr[1] == 'B001') {
              codeData.images.push({
                data: [
                  {
                    image_url: img.url,
                    image_id: img.image_id || '',
                    name: img.name,
                    file: img.file || '',
                    fileData: img.fileData || '',
                  },
                ],
                id: `${idArr[1]}_${idArr[2]}`,
              });
            }
          }
        }
      }
    }
  } else {
    if (info.business_range && info.business_range.length > 0) {
      for (k in info.business_range) {
        info.business_range[k] = addImgToIndustryData(info.business_range[k], img);
      }
    }
  }

  return info;
};

/**
 * 将图片从industryInfo中删除，通过image 的 name 来定位，将其从对应的images对象中删除
 *
 * @param      {object}  info    industryData
 * @param      {object}  img     The image
 */
export const deleteImgFromIndustryData = (industryData, img) => {
  const id = img.industry_id;
  const info = $.extend(true, {}, industryData);

  let item; let i; let j; let k; let p; let codeData; let images; let index; let idArr;

  if ((id && info.industry_id == id) || info.business_range_id == id) {
    if (info.certification_group) {
      for (i in info.certification_group) {
        item = info.certification_group[i];
        for (j in item.certification_codes) {
          codeData = item.certification_codes[j];
          images = codeData.images || [];

          // 需要区分删除多页资质的一页还是删除资质
          idArr = img.name.split('_');
          index = false;

          // 一页
          if (idArr.length == 3) {
            for (k in images) {
              for (p in images[k].data) {
                if (images[k].data[p].id == img.name) {
                  index = p;
                  break;
                }
              }
              if (index) {
                images[k].data.splice(index, 1);
                break;
              }
            }
            // 一份资质（补充资质）
          } else {
            for (k in images) {
              if (images[k].id == img.name) {
                index = k;
                break;
              }
            }
            if (index) {
              images.splice(index, 1); // 将资质从images中删掉
            }
          }
          // 清除对应 input DOM 的文件
          const inputDOM = $(`#${img.industry_id}_${img.name}`);
          if (inputDOM.length > 0 && inputDOM[0].files.length > 0) {
            inputDOM[0].value = '';
          }
        }
      }
    }
  } else {
    if (info.business_range && info.business_range.length > 0) {
      for (k in info.business_range) {
        info.business_range[k] = deleteImgFromIndustryData(info.business_range[k], img);
      }
    }
  }

  return info;
};

/**
 * 是否是补充资质
 */
export const isAdditional = (value) => {
  const urlRegex = /^-\w*22$/g;
  return urlRegex.test(value);
};

/**
 * 判断资质是否有有效的图片
 */
const hasValidImages = (certification, max_copy_count, min_copy_count) => {
  if (!certification.hasOwnProperty('images') || certification.images.length == 0) {
    return false;
  }

  let certiNum = 0;
  let pageNum = 0;

  for (let i in certification.images) {
    // 验证资质的其中一份是否有效
    pageNum = 0;

    if (!certification.images[i].hasOwnProperty('data')) {
      return false;
    }
    for (let j in certification.images[i].data) {
      if (certification.images[i].data[j].image_url || certification.images[i].data[j].image_id) {
        pageNum++;
      }
    }
    if (pageNum > certification.max_page_count || pageNum < certification.min_page_count) {
      // page 为 0 时，不报错，只是不计入资质总数，看最后资质总数是否符合要求
      if (pageNum !== 0) {
        return false;
      }
    } else {
      certiNum++;
    }
  }
  // 验证某个资质的份数是否有效
  if (certiNum < min_copy_count || certiNum > max_copy_count) {
    return false;
  }

  return true;
};

/**
 * 检查资质是否缺少图片
 *
 * @param      {object}   info    industryInfo
 * @return     {boolean}
 */
export const checkQualificationValidation = (info = {}, hasAddtionalCheck, checkedSubIndustries) => {
  let result; let i; let j; let item; let iteResult; let type; let certification;

  if (info.certification_group) {
    for (i in info.certification_group) {
      item = info.certification_group[i];
      type = item.certification_relation_type;

      // 验证第一张资质
      if (type == 'must') {
        certification = item.certification_codes[0];
        if (!hasValidImages(certification, item.max_copy_count, item.min_copy_count)) {
          return false;
        }
        // 选了有一张
      } else if (type == 'optional') {
        result = false;
        for (j in item.certification_codes) {
          certification = item.certification_codes[j];
          if (hasValidImages(certification, item.max_copy_count, item.min_copy_count)) {
            // 检查用户选择的是不是这个资质
            if (item.code_checked == item.certification_codes[j].certification_code) {
              result = true;
              break;
            }
          }
        }
        if (!result) {
          return false;
        }
      } else if (type == 'copy') {
        if (!hasValidImages(item.certification_codes[0], item.max_copy_count, item.min_copy_count)) {
          return false;
        }
      } else if (type == 'range') {
        if (!hasValidImages(item.certification_codes[0], item.max_copy_count, item.min_copy_count)) {
          return false;
        }
      }
    }

    if (info.business_range && info.business_range.length > 0) {
      for (i in info.business_range) {
        // 如果这个业务范围被选了，或者这是其他资质
        if (checkedSubIndustries.indexOf(info.business_range[i].business_range_id.toString()) > -1 || (isAdditional(info.business_range[i].business_range_id) && hasAddtionalCheck)) {
          iteResult = checkQualificationValidation(info.business_range[i], hasAddtionalCheck);
          if (!iteResult) {
            return false;
          }
        }
      }
    }
  }
  return true;
};

/**
 * 从industryData中获取有图片的资质，整理一下输出一个数组
 */
export const getQualificationCoded = (industryData, industry_id, qualificationCoded, checkedSubIndustries, hasAddtionalCheck) => {
  if (!industryData) {
    return;
  }
  let certification;
  let type;
  let images;
  let imgs = [];
  let codeData;
  let business_range_id = industryData.business_range_id || 0;

  for (let i in industryData.certification_group) {
    certification = industryData.certification_group[i];
    type = certification.certification_relation_type;
    imgs = [];
    if (type == 'must') {
      images = certification.certification_codes[0].images;
      if (images && images.length > 0) {
        // 取第一个资质的所有页数
        imgs = images[0].data;
        if (imgs.length > 0) {
          qualificationCoded.push({
            industry_id,
            business_range_id,
            code: certification.certification_codes[0].certification_code,
            images: imgs,
            certification_id: certification.certification_codes[0].certification_id,
            expand_fields: certification.certification_codes[0].expand_fields,
          });
        }
      }
    } else if (type == 'optional') {
      let certiId = '';
      for (let j in certification.certification_codes) {
        if (certification.certification_codes[j].certification_id) {
          certiId = certification.certification_codes[j].certification_id;
        }
        if (certification.certification_codes[j].certification_code == certification.code_checked) {
          codeData = certification.certification_codes[j];
        }
      }

      if (codeData) {
        images = codeData.images;
        if (images && images[0].data && images[0].data.length > 0) {
          qualificationCoded.push({
            industry_id,
            business_range_id,
            code: codeData.certification_code,
            images: images[0].data,
            certification_id: certiId,
            expand_fields: codeData.expand_fields,
          });
        }
      }
    } else if (type == 'copy' || type == 'range') {
      images = certification.certification_codes[0].images;
      if (images && images.length > 0) {
        for (let j in images) {
          if (images[j].data && images[j].data.length > 0) {
            qualificationCoded.push({
              industry_id,
              business_range_id,
              code: certification.certification_codes[0].certification_code,
              images: images[j].data,
              certification_id: certification.certification_codes[0].certification_id,
              expand_fields: certification.certification_codes[0].expand_fields,
            });
          }
        }
      }
    }
  }

  if (industryData.business_range && industryData.business_range.length > 0) {
    for (let i in industryData.business_range) {
      let isAdditionalQuali = isAdditional(industryData.business_range[i].business_range_id.toString());
      if (checkedSubIndustries.indexOf(industryData.business_range[i].business_range_id.toString()) > -1 || (isAdditionalQuali && hasAddtionalCheck)) {
        getQualificationCoded(industryData.business_range[i], industry_id, qualificationCoded, checkedSubIndustries, hasAddtionalCheck);
      }
    }
  }

  return qualificationCoded;
};

/**
 * 比较两个资质里的图片是否一样
 */
const compareImages = (oldImgaes, newImages) => {
  if (oldImgaes.length != newImages.length) {
    return false;
  }

  let index;
  let oldImgaesFormatted = [];

  for (let j in oldImgaes) {
    oldImgaesFormatted.push(oldImgaes[j].image_id);
  }

  for (let i = 0; i < newImages.length; i++) {
    index = oldImgaesFormatted.indexOf(newImages[i]);
    if (index > -1) {
      oldImgaesFormatted.splice(index, 1);
    } else {
      return false;
    }
  }

  return true;
};

/**
 * 比较两个资质是否相同
 */
export const compareQualificationCoded = (oldData, newData) => {
  if (oldData.length != newData.length) {
    return false;
  }

  let index; let item;

  for (let i in newData) {
    item = newData[i];
    index = -1;

    // 遍历旧资质，找是否有这个资质
    for (let i in oldData) {
      if (item.industry_id == oldData[i].industry_id && item.business_range_id == oldData[i].business_range_id && item.code == oldData[i].code && compareImages(item.images, oldData[i].images)) {
        index = i;
      }
    }

    if (index > -1) {
      oldData.splice(index, 1);
    } else {
      return false;
    }
  }

  return true;
};

export default {
  formatCertificationData,
  formatCertificationDataByInit,
  setOptionalCodeChecked,
  addImgToIndustryData,
  deleteImgFromIndustryData,
  checkQualificationValidation,
  isAdditional,
  findCertification,
  getQualificationCoded,
  compareQualificationCoded,
};
